import React, { Component } from 'react'
import { Link } from "react-router-dom";
import Logo from "../assets/images/logo.png";

class Admin extends Component {
    constructor(props) {
        super(props)

        this.state = {
                 
        }
    }

    render() {
        return (
            <div>
                <nav>
				<div className="header">
					<Link to="/">
						<img src={Logo} alt="" className="logo" />
					</Link>
				</div>
			</nav>
                Admin
            </div>
        )
    }
}

export default Admin
